module.exports = () => {
  return [
    {
      name: '任务ID',
      value: 'id',
    },
    {
      name: '任务名称',
      value: 'name',
    },
    {
      name: '任务状态',
      value: 'status',
      format: (row) => {
        const text_map = {
          BILLING_IN_PROGRESS: '计费中',
          CANCELLED: '任务已取消',
          COMPLETED: '任务完成',
          PENDING_LAUNCH: '任务待启动',
          PREPARATION: '任务准备',
        };
        return text_map[row.status] || row.status;
      },
    },
    {
      name: '可投放视频数',
      value: 'can_delivery_item_count',
    },
  ];
};
